import React, { useContext, useEffect, useState } from "react";
import "./Near_By_Stores.css";
import Common_Heading_Holder from "../../Common-Component/common_heading_holder/Common_Heading_Holder";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { getData } from "../../../utils/api";
import { Context } from "../../../utils/context";
import { useNavigate } from "react-router-dom";
import { CategoryProduct } from "../../../utils/apis/Product/Product";

const Near_By_Stores = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const { IMG_URL, getData, triggerCartUpdate } = useContext(Context);

  const [sellerByCategory, setSellerByCategory] = useState([]);
  const [store, setStore] = useState([]);
  

  const getSellerByCat = async (id) => {
    const res = await getData(
      `/without-login/home/seller-product-category?category_id=${id}`
    );
    if (res?.success) {
      setSellerByCategory(res?.data);
    }
  };

  const Store = async () => {
    const res = await getData(`/shop`);
    if (res?.success) {
      setStore(res?.data);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    getSellerByCat();
    Store();
  }, []);

   const [category, setCategory] = useState([]);
   const getCategory = async () => {
    const res = await CategoryProduct();

    if (res?.success) {
      setCategory(res?.data);
    }

  }
  useEffect(() => {
    getCategory();
  }, []);


  return (
    <section className="Near_By_Stores">
      <Common_Heading_Holder headingText={"Near by Stores"} />

      <div className="all_products_holder">
        {category?.length > 0 ? (
          <Swiper
            spaceBetween={30}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            onSwiper={(swiper) => setSwiperInstance(swiper)}
            className="mySwiper"
            breakpoints={{
              0: {
                slidesPerView: 3,
              },
              420: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              486: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 6,
              },
              992: {
                slidesPerView: 6,
              },
              1200: {
                slidesPerView: 7,
              },
              1400: {
                slidesPerView: 8,
              },
            }}
          >
            {category?.map((value, index) => {
              return (
                <SwiperSlide key={index}>
                  <div
                    className="product_holder"
                    onClick={() => navigate(`/near-me?category_id=${value?.id}`)}
                  >
                    <div className="img_holder">
                      <img src={IMG_URL + value?.image} className="inner_img" />
                    </div>
                    <p className="prod_name">{value?.name}</p>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : (
          <div className="no-products-found">
            <h4 className="align-center">No Product Available</h4>
          </div>
        )}
      </div>
    </section>
  );
};

export default Near_By_Stores;
